import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {catchError, firstValueFrom, map, of, switchMap, tap} from "rxjs";
import {SessionService} from "../state/session.service";
import {AppService} from "../app.service";
import {UserService} from "../user-list/service/user.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private refreshPromise: Promise<void> | null = null;

  constructor(private readonly httpClient: HttpClient,
              private readonly appService: AppService,
              private readonly userService: UserService,
              private readonly session: SessionService) {
  }

  login(req: { username: string, password: string }) {
    return this.httpClient.post<{ token: string }>(environment.API_URL + '/api/login', req)
      .pipe(
        tap((user) => this.session.setAuthToken(user.token)),
        switchMap(() => this.userService.fetchUser()),
        switchMap(() => this.appService.init()),
        map(() => true)
      );
  }

  refreshToken(): Promise<void> {
    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    this.refreshPromise = firstValueFrom(
      this.httpClient.get<{ username: string, token: string }>(environment.API_URL + '/api/login/refresh')
        .pipe(
          tap((user) => this.session.setAuthToken(user.token)),
          switchMap(() => this.userService.fetchUser()),
          switchMap(() => this.appService.init()),
          map(() => void 0),
          catchError((error) => {
            console.error('Failed to refresh session', error);
            this.session.setAuthToken(undefined);
            this.session.user = undefined;
            return of(void 0);
          })
        )
    ).finally(() => {
      this.refreshPromise = null;
    });

    return this.refreshPromise;
  }
}
